module.exports = __webpack_public_path__ + "img/pethouse00.6970eb51.jpg";